module.exports = __webpack_public_path__ + "static/media/compliance.b647f178.webp";